document.addEventListener('DOMContentLoaded', function () {

    const popup = document.getElementById('career-popup');

    if (!popup) return;

    function openCareerPopup() {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closeCareerPopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {

        const link = e.target.closest('a');

        if (!link) return;

        const href = link.getAttribute('href');

        if (href === '/careers-page') {

            e.preventDefault();

            openCareerPopup();
        }
    });

    popup
        .querySelector('.career-popup__close')
        .addEventListener('click', closeCareerPopup);

    popup
        .querySelector('.career-popup__overlay')
        .addEventListener('click', closeCareerPopup);

});